import React, { useState, useEffect } from 'react';
import supabase from './supabaseClient';
import NotificationCenter from './NotificationCenter';

export default function NotificationBell() {
  const [unreadCount, setUnreadCount] = useState(0);
  const [isNotificationCenterOpen, setIsNotificationCenterOpen] = useState(false);

  // Load unread count
  const loadUnreadCount = async () => {
    try {
      const { data, error } = await supabase
        .from('notifications')
        .select('id')
        .is('read_at', null);

      if (error) throw error;

      setUnreadCount(data?.length || 0);
    } catch (error) {
      console.error('Error loading unread count:', error);
    }
  };

  // Real-time subscription for unread count
  useEffect(() => {
    loadUnreadCount();

    // Subscribe to real-time notifications
    const subscription = supabase
      .channel('notification-count')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'notifications' 
        },
        () => {
          // Reload count when notifications change
          loadUnreadCount();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <>
      <button
        onClick={() => setIsNotificationCenterOpen(true)}
        className="relative p-1 text-[#666] hover:text-[#0eeaff] hover:bg-[#f0f0f0] rounded transition-colors flex items-center"
        title="Notifications"
      >
        <div className="text-lg">🔔</div>
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      <NotificationCenter
        isOpen={isNotificationCenterOpen}
        onClose={() => setIsNotificationCenterOpen(false)}
      />
    </>
  );
} 